import React, { useState } from 'react';
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import Cookies from "js-cookie";

const GoogleLoginButton = ({ history }) => {
  const handleLogin = async (google_response) => {
    console.log("Google response:", google_response);
    // return "";
    // Можно отправить response.credential (JWT) на backend для валидации

    // const taskData_tmp = Cookies.get('taskData'); // read cookie
    // let taskData = null;
    // try {
    //     taskData = JSON.parse(taskData_tmp);
    // } catch (err) {
    //     console.error('Invalid JSON in cookie:', err);
    // }

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const data = {
        "google_response": google_response,
        "task": null
      }
      const response = await axios.post(`${apiURL}/api/user/login_google_create_task`, data);
      if(response.data.status == 'ok') {
        Cookies.set('token', response.data.token, { expires: 1, path: '/'});
        Cookies.set('email', response.data.email, { expires: 1, path: '/'});
        history.push("/");
        // window.location.href = `https://app.bettrleads.com/page-login-token?token=${response.data.token}`;
      } else if(response.data.status == 'error') {
        
      }

    } catch (error) {
      console.error("Error sending POST request:", error);
      // await delayFunction(2000);
      // await handleLogin(google_response);
    } finally {
      // setLoading(false);
    }
  };
  
  return (
    <div className="d-flex justify-content-center align-items-center">
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        {/* <div className="App w-full"> */}
          <GoogleLogin
            onSuccess={handleLogin}
            onError={() => {
              console.log("Login Failed");
            }}
          />
        {/* </div> */}
      </GoogleOAuthProvider>
    </div>
  );
};

export default GoogleLoginButton;